exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled[data-v-018aaba0]{font-style:italic;margin-bottom:0}.custom-loader[data-v-018aaba0]{animation:loader-data-v-018aaba0 1s infinite;display:flex}@-moz-keyframes loader-data-v-018aaba0{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@-webkit-keyframes loader-data-v-018aaba0{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@-o-keyframes loader-data-v-018aaba0{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@keyframes loader-data-v-018aaba0{0%{transform:rotate(0)}to{transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-018aaba0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SignUp.vue
// module id = 267
// module chunks = 0